import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course03 from "../../../course/course-03/course";
import lesson0303 from "../lesson-03/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "8db1f1e8-229e-416a-a9fd-e452e2c6fba4",
    course: {
      id: course03.id,
      slug: course03.slug as string,
      name: course03.name,
      publicId: course03.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course03, lesson0303),
    lesson: lesson0303,
  },
];

export default lessonLinks;
